import { render, staticRenderFns } from "./ShipDetail.vue?vue&type=template&id=45b9cd5c&scoped=true"
import script from "./ShipDetail.vue?vue&type=script&lang=js"
export * from "./ShipDetail.vue?vue&type=script&lang=js"
import style0 from "./ShipDetail.vue?vue&type=style&index=0&id=45b9cd5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b9cd5c",
  null
  
)

export default component.exports